import { useEffect, useState } from "react";
import { BreakpointType } from "../../../Container/ContainerFluid";
import { useBreakpoint } from "../../../Container/ContainerStyles";
import { ContextualMenu, IconButton, IDragOptions, MessageBarType, Modal, Stack, Text } from "@fluentui/react";
import { containerStyles, formContainerStyles, lgContainerStyles, lgSubTitleStyles, lgTitleContainerStyles, lgTitleStyles, mdContainerStyles, mdSubTitleStyles, mdTitleContainerStyles, mdTitleStyles, smContainerStyles, smSubTitleStyles, smTitleContainerStyles, smTitleStyles, subTitleStyles, titleContainerStyles, titleStyles, xlContainerStyles, xlSubTitleStyles, xlTitleContainerStyles, xlTitleStyles, xxlContainerStyles, xxlSubTitleStyles, xxlTitleContainerStyles, xxlTitleStyles } from "../Common/Styles/CommonStyles";
import { lgListContainerStyles, listContainerStyles, mdListContainerStyles, modalContentStyles, modalIconButtonStyles, smListContainerStyles, xlListContainerStyles, xxlListContainerStyles } from "./Styles/RegisterScenarioStyles";
import { RegisterDatePicker } from "../Common/RegisterField";
import { datePickerStyles, mdDatePickerStyles, smDatePickerStyles } from "../Common/Styles/RegisterFieldStyles";
import { RegisterScenarioRow } from "./Components/RegisterScenarioRow";
import { IRegisterContext, useRegisterContext } from "../../RegisterContainer";
import { LeadLiveMode } from "../../../../../Model/PartnerModels";
import { RegisterMessageBar } from "../Common/RegisterErrorBar";
import { RegisterService } from "../../Service/RegisterService";
import { t } from "i18next";

export const RegisterScenario: React.FC = () => {
    const registerContext: IRegisterContext = useRegisterContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [suggestedText, setSuggestedText] = useState<string>("");
    const [liveMode, setLiveMode] = useState<LeadLiveMode>(registerContext.leadToLive.lead.liveMode);
    const [decisionDate, setDecisionDate] = useState<Date | null | undefined>(registerContext.leadToLive.lead.decisionDate);
    
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    const modalDragOptions: IDragOptions = {
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu,
        keepInBounds: true,
        dragHandleSelector: '.ms-Modal-scrollableContent > div:first-child',
    }

    const handleChanged = (mode?: LeadLiveMode, decisionDate?: Date | null | undefined) => {
        setLiveMode(mode!);
        setDecisionDate(decisionDate!);

        registerContext.setLeadToLive({
            ...registerContext.leadToLive,
            lead: {
                ...registerContext.leadToLive.lead,
                decisionDate: decisionDate!,
                liveMode: mode!
            }
        });
    };

    return (
        <>
            <Stack
                className={
                    isSM ? 
                        smContainerStyles : 
                    isMD ? 
                        mdContainerStyles :
                    isLG ?
                        lgContainerStyles :
                    isXL ?
                        xlContainerStyles :
                    isXXL ?
                        xxlContainerStyles
                    :
                        containerStyles
                }
            >
                <Stack
                    className={
                        isSM ? 
                            smTitleContainerStyles : 
                        isMD ? 
                            mdTitleContainerStyles :
                        isLG ?
                            lgTitleContainerStyles :
                        isXL ?
                            xlTitleContainerStyles :
                        isXXL ?
                            xxlTitleContainerStyles
                        :
                            titleContainerStyles
                    }
                >
                    <Text 
                        className={
                            isSM ? 
                                smTitleStyles : 
                            isMD ? 
                                mdTitleStyles : 
                            isLG ?
                                lgTitleStyles :
                            isXL ?
                                xlTitleStyles :
                            isXXL ?
                                xxlTitleStyles
                            :
                                titleStyles
                        }
                    >
                        {RegisterService.translate("scenario:title")}
                    </Text>
                    <Text 
                        className={
                            isSM ? 
                                smSubTitleStyles : 
                            isMD ? 
                                mdSubTitleStyles :
                            isLG ?
                                lgSubTitleStyles :
                            isXL ?
                                xlSubTitleStyles :
                            isXXL ?
                                xxlSubTitleStyles
                            :
                                subTitleStyles
                        }
                    >
                        {RegisterService.translate("scenario:description")}
                    </Text>
                </Stack>
                <Stack
                    className={formContainerStyles}
                >
                    <Stack>
                        <RegisterMessageBar 
                            type={MessageBarType.error}
                            visible={registerContext.registerError.hasError}
                            message={RegisterService.getErrorMessage(registerContext.registerError)}
                        />
                    </Stack>
                    <Stack>
                        <RegisterDatePicker 
                            autoFocus
                            onChange={(date) => {handleChanged(liveMode, date)}}
                            placeholder={RegisterService.translate("scenario:decisionDate")}
                            value={decisionDate!}
                        />
                    </Stack>
                    <Stack
                        className={
                            isSM ? 
                                smListContainerStyles : 
                            isMD ? 
                                mdListContainerStyles :
                            isLG ?
                                lgListContainerStyles :
                            isXL ?
                                xlListContainerStyles :
                            isXXL ?
                                xxlListContainerStyles
                            :
                                listContainerStyles
                        }
                    >
                        <RegisterScenarioRow 
                            title={RegisterService.translate("scenario:immidiateRowTitle")}
                            description={RegisterService.translate("scenario:immidiateRowDescription")}
                            suggestText={t('common:qualification:Text0017Lbl')}
                            onChange={() =>{handleChanged(LeadLiveMode.ImmidiateLive, decisionDate)}}
                            selected={liveMode == LeadLiveMode.ImmidiateLive}
                            onOpenSuggestModal={(content) => { 
                                setIsModalOpen(true);
                                setSuggestedText(content);
                            }}
                        />
                        <RegisterScenarioRow 
                            title={RegisterService.translate("scenario:shortTimeRowTitle")}
                            description={RegisterService.translate("scenario:shortTimeRowDescription")}
                            suggestText={t('common:qualification:Text0021Lbl')}
                            onChange={() =>{handleChanged(LeadLiveMode.ShortTimeChange, decisionDate)}}
                            selected={liveMode == LeadLiveMode.ShortTimeChange}
                            onOpenSuggestModal={(content) => { 
                                setIsModalOpen(true);
                                setSuggestedText(content);
                            }}
                        />
                        <RegisterScenarioRow 
                            title={RegisterService.translate("scenario:scaredChangeRowTitle")}
                            description={RegisterService.translate("scenario:scaredChangeRowDescription")}
                            suggestText={t('common:qualification:Text0025Lbl')}
                            onChange={() =>{handleChanged(LeadLiveMode.AllFeatureValuation, decisionDate)}}
                            selected={liveMode == LeadLiveMode.AllFeatureValuation}
                            onOpenSuggestModal={(content) => { 
                                setIsModalOpen(true);
                                setSuggestedText(content);
                            }}
                        />
                        <RegisterScenarioRow 
                            title={RegisterService.translate("scenario:noPlanRowTitle")}
                            description={RegisterService.translate("scenario:noPlanRowDescription")}
                            suggestText={t('common:qualification:Text0028Lbl')}
                            onChange={() =>{handleChanged(LeadLiveMode.NoClearGoals, decisionDate)}}
                            selected={liveMode == LeadLiveMode.NoClearGoals}
                            onOpenSuggestModal={(content) => { 
                                setIsModalOpen(true);
                                setSuggestedText(content);
                            }}
                        />
                    </Stack>
                </Stack>
            </Stack>
            <Modal
                titleAriaId={"ModalRow"}
                isOpen={isModalOpen}
                onDismiss={() => setIsModalOpen(false)}
                isBlocking={false}
                containerClassName={modalContentStyles.container}
                dragOptions={modalDragOptions}
            >
                <div 
                    className={modalContentStyles.header}
                >
                    <h2 
                        className={modalContentStyles.heading}
                    >
                        {RegisterService.translate("scenario:infoText")}
                    </h2>
                    <IconButton
                        styles={modalIconButtonStyles}
                        iconProps={{ iconName: 'Cancel' }}
                        ariaLabel="Close popup modal"
                        onClick={() => setIsModalOpen(false)}
                    />
                </div>
                <div
                    className={modalContentStyles.body}
                >
                    {suggestedText}
                </div>
            </Modal>
        </>
    );
};